import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { useLang } from '../i18n';

export default function PrivacyPolicy() {
  const { t } = useLang();
  return (
    <div className="max-w-3xl mx-auto px-6 py-16 md:py-20 text-white/85" data-testid="privacy-policy-page">
      <Link to="/" className="inline-flex items-center gap-2 text-[color:var(--yup-primary)] mb-8 hover:underline text-sm">
        <ArrowLeft size={16} /> {t('backHome')}
      </Link>
      <h1 className="text-3xl md:text-4xl font-bold text-[color:var(--yup-primary)] mb-2">Privacy Policy</h1>
      <p className="text-white/60 text-sm mb-10">Ultimo aggiornamento: 19 Febbraio 2026</p>

      <div className="space-y-8 leading-relaxed">
        <section>
          <h2 className="text-xl font-semibold text-white mb-2">1. Titolare del trattamento</h2>
          <p>Titolare del trattamento è <strong>YUP – Your Utility Points</strong>. Per qualsiasi richiesta relativa ai tuoi dati personali puoi contattarci all'indirizzo <a href="mailto:info@diamondinnovations.eu" className="text-[color:var(--yup-primary)] underline">info@diamondinnovations.eu</a>.</p>
        </section>

        <section>
          <h2 className="text-xl font-semibold text-white mb-2">2. Dati raccolti</h2>
          <p>Raccogliamo i dati che ci fornisci volontariamente (es. iscrizione alla newsletter) e dati tecnici di navigazione (indirizzo IP anonimizzato, tipo di browser, pagine visitate) tramite cookie e log server, nel rispetto del <strong>GDPR (UE 2016/679)</strong>.</p>
          <ul className="list-disc list-inside mt-3 space-y-1 text-white/75">
            <li><strong>Newsletter:</strong> email, lingua, consenso.</li>
            <li><strong>Chatbot AI:</strong> testo dei messaggi inviati, ID sessione temporaneo.</li>
            <li><strong>Geolocalizzazione (Vicino a me):</strong> coordinate approssimative solo se autorizzi il browser. Non vengono salvate sui nostri server.</li>
            <li><strong>Cookie tecnici e analitici:</strong> vedi <Link to="/cookie-policy" className="text-[color:var(--yup-primary)] underline">Cookie Policy</Link>.</li>
          </ul>
        </section>

        <section>
          <h2 className="text-xl font-semibold text-white mb-2">3. Finalità e base giuridica</h2>
          <ul className="list-disc list-inside space-y-1 text-white/75">
            <li>Fornire il servizio richiesto (contratto, art. 6.1.b GDPR).</li>
            <li>Inviarti la newsletter (consenso, art. 6.1.a GDPR).</li>
            <li>Migliorare il sito e rilevare abusi (legittimo interesse, art. 6.1.f GDPR).</li>
            <li>Adempiere obblighi di legge (art. 6.1.c GDPR).</li>
          </ul>
        </section>

        <section>
          <h2 className="text-xl font-semibold text-white mb-2">4. Conservazione dei dati</h2>
          <p>Conserviamo gli iscritti alla newsletter finché non richiedono la cancellazione. I log tecnici sono conservati per un massimo di 12 mesi. I dati del chatbot sono anonimizzati dopo 30 giorni.</p>
        </section>

        <section>
          <h2 className="text-xl font-semibold text-white mb-2">5. Condivisione con terzi</h2>
          <p>I tuoi dati non sono venduti. Possono essere condivisi con fornitori che ci aiutano a erogare il servizio:</p>
          <ul className="list-disc list-inside mt-3 space-y-1 text-white/75">
            <li><strong>MongoDB Atlas / hosting cloud</strong> per la persistenza dati (UE).</li>
            <li><strong>OpenAI / provider AI</strong> per il chatbot (dati processati secondo le loro policy).</li>
            <li><strong>OpenStreetMap / Nominatim / Open-Meteo</strong> per mappe e meteo (nessun dato personale inviato).</li>
          </ul>
        </section>

        <section>
          <h2 className="text-xl font-semibold text-white mb-2">6. I tuoi diritti (artt. 15-22 GDPR)</h2>
          <p>Puoi accedere, rettificare, cancellare, limitare o portare i tuoi dati, oppure opporti al trattamento. Puoi revocare il consenso in ogni momento scrivendo a <a href="mailto:info@diamondinnovations.eu" className="text-[color:var(--yup-primary)] underline">info@diamondinnovations.eu</a>. Hai inoltre diritto di reclamo al Garante Privacy italiano.</p>
        </section>

        <section>
          <h2 className="text-xl font-semibold text-white mb-2">7. Sicurezza</h2>
          <p>Utilizziamo HTTPS, hashing delle password (bcrypt), autenticazione JWT e accesso limitato al database. Il codice è ospitato su infrastruttura cloud UE.</p>
        </section>

        <section>
          <h2 className="text-xl font-semibold text-white mb-2">8. Modifiche</h2>
          <p>Ci riserviamo il diritto di aggiornare questa Privacy Policy. La data in alto indica l'ultima revisione.</p>
        </section>
      </div>
    </div>
  );
}
